"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorReporterProvider = exports.ErrorReporterBoundary = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _reporter = require("./reporter");

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ErrorReporterContext = /*#__PURE__*/_react.default.createContext({
  onError: _noop.default
});

var ErrorReporterProvider = function ErrorReporterProvider(_ref) {
  var children = _ref.children,
      onError = _ref.onError;
  var memoErrorFn = (0, _react.useCallback)(function (e) {
    return (0, _reporter.stacktrace)(e).then(function (msg) {
      return onError(msg);
    });
  }, [onError]);
  return /*#__PURE__*/_react.default.createElement(ErrorReporterContext.Provider, {
    value: {
      onError: memoErrorFn
    }
  }, children);
};

exports.ErrorReporterProvider = ErrorReporterProvider;
ErrorReporterProvider.propTypes = {
  children: _propTypes.default.any,
  onError: _propTypes.default.func.isRequired
};

var ErrorReporterBoundary = function ErrorReporterBoundary(props) {
  var _useContext = (0, _react.useContext)(ErrorReporterContext),
      onError = _useContext.onError;

  var memoFn = (0, _react.useCallback)(function (e) {
    return onError(e);
  }, [onError]);
  return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, (0, _extends2.default)({}, props, {
    onError: memoFn
  }));
};

exports.ErrorReporterBoundary = ErrorReporterBoundary;